(
    function (skyward, $)
    {
        "use strict";
        skyward.reporting.treebrowse = skyward.reporting.treebrowse || {};


        skyward.reporting.treebrowse.getTreeBrowse = function (data, calculatedFieldData, valueBox, ajaxURL, options)
        {
            var defaults = {
                title: "Select Field",
                triggerChange: true,
                modalLayerOptions: {}
            };
            options = $.extend({}, defaults, options);

            var treeBrowsePopup;

            var requestFieldColumnPopup = function ()
            {
                data.mode = "report";
                return $.ajax(skyward.global.virtualDir + ajaxURL,
                    {
                        type: "POST",
                        dataType: "HTML",
                        data: data,
                        dataFilter: function (html)
                        {
                            return "<div style='max-height: 500px'>" + html + "</div>";
                        }
                    });
            };

            var saveButtonClicked = function ()
            {
                const selectedData = skyward.treebrowse.getSelectedFieldData(treeBrowsePopup.content);
                if (selectedData)
                {
                    const baseData =
                    {
                        fieldType: selectedData.fieldType,
                        fieldPath: null,
                        dataObjectFullName: selectedData.dataObjectFullName,
                        displayName: selectedData.displayName,
                        isCalculated: selectedData.isCalculated,
                        isOperation: selectedData.isOperation,
                        parameters: selectedData.parameters
                    };
                    if (selectedData.absoluteFieldPath)
                    {
                        setValueControl(valueBox, selectedData.displayPathText, $.extend({ fieldName: selectedData.absoluteFieldPath }, baseData), selectedData.svgClass);
                    }
                    else if (selectedData.fieldName && !selectedData.isCalculatedField)
                    {
                        const correctedFieldName = selectedData.fieldName.substring(selectedData.fieldName.indexOf(".") + 1);

                        setValueControl(valueBox, selectedData.displayPathText, $.extend({ fieldName: correctedFieldName }, baseData), selectedData.svgClass);
                    }
                    else if (selectedData.id)
                    {
                        setValueControl(valueBox, selectedData.displayPathText, $.extend({ calculatedFieldName: selectedData.id }, baseData), selectedData.svgClass);
                    }
                }

                skyward.window.closePopup(treeBrowsePopup, "save");
            };

            var setValueControl = function (valueControl, displayValue, fieldData, svgClass)
            {
                valueControl.setAllDataToNull();
                valueControl.text("");
                valueControl.removeClass("hidden");

                if (fieldData.fieldType && fieldData.fieldType.indexOf("Enum") >= 0)
                {
                    fieldData.enumType = fieldData.fieldType;
                }

                valueControl.data(fieldData);
                const text = $("<span/>").addClass('fieldSelectorText').text(displayValue);

                if (svgClass)
                {
                    const svg = skyward.svg.getSvg(svgClass, "TreeBrowse");
                    const svgHolder = $("<span/>").addClass("svgHolder");
                    svgHolder.html(svg);
                    valueControl.append(svgHolder).append(text);
                }
                else
                {
                    valueControl.text(displayValue);
                }

                if (options.triggerChange)
                {
                    valueControl.trigger("change");
                }
            };

            var treeBrowseChanged = function (event, data)
            {
                var saveButton = treeBrowsePopup.footer.find(".filterSaveButton");
                var saveButtonTextSpan = saveButton.find(".modalContentFooter__buttonText");

                saveButton.data("treeBrowseData", data);

                if (data.isDataField)
                {
                    saveButtonTextSpan.text("Select Field");
                    saveButton.show();
                }
                else if (data.isCalculatedField)
                {
                    saveButtonTextSpan.text("Select Calculated Field");
                    saveButton.show();
                }
                else
                {
                    saveButton.hide();
                }
            };

            var modalLayerPromise = $.Deferred();
            requestFieldColumnPopup().done(function (contents)
            {
                var saveButton = { text: "Select Field", click: saveButtonClicked, icon: "Save", additionalClasses: ["filterSaveButton"] };
                var cancelButton = { text: "Cancel", click: "close", icon: "Cancel" };
                var modalLayerOptions = $.extend({ animationDuration: 0, draggable: true, closeOnClick: false }, options.modalLayerOptions);
                var jqContents = $(contents);
                var buttons = [saveButton, cancelButton];

                treeBrowsePopup = skyward.modalLayer.showDialog(options.title, jqContents, buttons, modalLayerOptions);
                treeBrowsePopup.animationPromise.done(function ()
                {
                    treeBrowsePopup.content.on("treeBrowseLevelChanged", treeBrowseChanged).on("treeBrowseRowChange", treeBrowseChanged);
                    treeBrowsePopup.content.on("treeBrowseSave", saveButtonClicked);

                    if (data.includeCalculatedFields)
                    {
                        treeBrowsePopup.content.one("treeBrowseInitialize", function (_event, treeBrowseData)
                        {
                            var validCalculatedFields = data.fieldDataType === undefined ?
                                skyward.reporting.calculatedFields.AllFields() : skyward.reporting.calculatedFields.AllFieldsOfType(data.fieldDataType);
                            skyward.calculatedFieldList.updateCalculatedFieldList(
                                treeBrowseData,
                                Object.values(validCalculatedFields),
                                undefined,
                                calculatedFieldData.calculatedFieldRootModule || data.rootModule,
                                calculatedFieldData.calculatedFieldRootObject || data.rootObject,
                                calculatedFieldData.calculatedFieldRelationshipPath,
                                undefined
                            );
                        });
                    }

                    modalLayerPromise.resolve(treeBrowsePopup);
                });
            });
            return modalLayerPromise.promise();
        };

    }(window.skyward = window.skyward || {}, window.jQuery)
);
